exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-5296f767] .template-page{border:2px dotted black;background-color:whitesmoke;margin-bottom:12px;padding:20px;padding-bottom:0px}[data-v-5296f767] .template-page.selected-page{border:2px dashed gray}\n", ""]);

